import React from "react";
import { Github } from "lucide-react";

const FlagMark = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <rect x="0" y="0" width="28" height="28" rx="4" fill="#FFC82E" />
    <rect x="11" y="0" width="6" height="28" fill="#E01F26" />
    <rect x="0" y="11" width="28" height="6" fill="#E01F26" />
    <rect x="12.5" y="0" width="3" height="28" fill="#FDFDFD" />
    <rect x="0" y="12.5" width="28" height="3" fill="#FDFDFD" />
  </svg>
);

export default function Topbar({ processedToday = 0 }) {
  return (
    <header
      className="flex items-center justify-between px-6 py-3 border-b border-[#27272A] bg-[#0A0A0A] relative z-10"
      data-testid="app-topbar"
    >
      <div className="flex items-center gap-3">
        <FlagMark />
        <div className="flex flex-col leading-none">
          <span className="font-display font-black text-lg tracking-tight">
            DELOGO<span className="text-[#E01F26]">.</span>STUDIO
          </span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#71717A] mt-1">
            Winnipeg · MB
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div
          className="hidden sm:flex items-center gap-2 font-mono-pro text-xs text-[#A1A1AA]"
          data-testid="usage-counter"
        >
          <span className="rec-dot inline-block w-1.5 h-1.5 rounded-full bg-[#E01F26]" />
          <span>
            {processedToday} <span className="text-[#71717A]">procesados hoy</span>
          </span>
        </div>

        <span
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm border text-[11px] font-bold uppercase tracking-[0.18em] bg-[#FFC82E] text-[#0A0A0A] border-[#FFC82E]"
          data-testid="tier-badge"
        >
          Unlimited
        </span>

        <a
          href="https://ffmpeg.org/ffmpeg-filters.html#delogo-1"
          target="_blank"
          rel="noreferrer"
          className="hidden md:inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-[#71717A] hover:text-[#FDFDFD] transition-colors"
          data-testid="docs-link"
        >
          <Github size={13} strokeWidth={1.5} /> FFmpeg delogo
        </a>
      </div>
    </header>
  );
}
